import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodeprojectComponent } from './simple-icons-codeproject.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodeprojectComponent ],
    exports:      [ SimpleIconsCodeprojectComponent ],
    bootstrap:    []
})
export class SimpleIconsCodeprojectModule {}
